import NavMenuItem from "../ui/nav-menu-item";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import SideBarContext from "../../contexts/side-bar-context";
import { useContext } from "react";
import DynamicIcon from "../ui/dynamic-icon";
import DomainContext from "../../contexts/domain-context";
import { useTranslations } from "next-intl";

const BottomMenuItems = () => {
  const userCtx = useContext(UserContext);
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  const user = userCtx.user;
  const { isSettingsOpen, toggleSettings } = useContext(SideBarContext);
  const { checkIfUserHasEmail } = useContext(DomainContext);
  const t = useTranslations('nav');

  return (
    <div className="grid gap-[4px] mb-[20px]">
      {(user.is_pseudonymous === false && business.is_pseudonymous === false) && checkIfUserHasEmail() &&
        <>
          <div className="lg:hidden block">
            <NavMenuItem icon='settings' href='/settings'>{t('settings')}</NavMenuItem>
          </div>
          <div className="hidden lg:block">
            <NavMenuItem icon='settings' href='/manage-people'>{t('settings')}</NavMenuItem>
          </div>
        </>
      }
      <NavMenuItem normalizeRoute newTab icon='bug' href="https://forms.gle/rqLWcSkrpiNouynD8">{t('reportABug')}</NavMenuItem>
      <NavMenuItem normalizeRoute newTab icon='life-buoy' href="https://docs.google.com/forms/d/e/1FAIpQLScIaAP1FSbZuFGwPsxp4ojs8IkK0IT29JsAdOtrKAlpiaMQhg/viewform">{t('help&support')}</NavMenuItem>
    </div>
  );
};

export default BottomMenuItems;
